import React from "react";
import { Link } from "react-router-dom";
import { Alert, Button, Form } from "react-bootstrap";
import { doLogin } from "./api/doLogin";
import { LoginTerms } from "./disclaimer/LoginTerms";
import { _t } from "../../app/i18n/i18n";
import { LanguageSelector } from "./LanguageSelector";
import { NomuraLogo } from "./NomuraLogo";
import { ErrorMsg } from "./ChangePassword";
import "./login.css";
import { features } from "../../app/features";

function handleLogin(e) {
  e.preventDefault();
  const form = e.target;
  const username = form.username.value;
  const password = form.password.value;
  doLogin(username, password);
}

function getMagicLink() {
  if (features.isMagicLinkVisible) {
    return (
      <>
        <div className="mt-3 d-flex align-content-center flex-nowrap">
          <hr id="magiclink"></hr>
          <p className="mt-2"> {_t("OR")} </p>
          <hr id="magiclink"></hr>
        </div>
        <header className="mt-0 mb-3 text-center font-weight-lighter h5">{_t("LOGIN WITHOUT A PASSWORD")}</header>
        <p className="mt-0 mb-3 text-center font-weight-lighter ">
          {_t("We will email you an access link, so you can login without typing your password.")}
        </p>
        <Link to="/public/magic-link" className="w-100 text-white text-center d-block my-1">
          <Button id="magicLink-button" variant="outline-light my-3" className="w-100 more-border-radius" type="submit">
            {_t("Email me a Link")}
          </Button>
        </Link>
      </>
    );
  }
}

export const LogIn = ({ location }) => {
  return (
    <section className="w-100 screen-height text-white bg-dark p-5 position-relative">
      <Form className="maxw-600" onSubmit={handleLogin}>
        <LanguageSelector />
        <NomuraLogo />
        <header className="mt-0 mb-3 text-center font-weight-lighter h5">{_t("Global Research Portal")}</header>

        <Form.Group className="mt-5">
          <Form.Label>{_t("Email address")}</Form.Label>
          <Form.Control
            type="email"
            name="username"
            placeholder={_t("Enter email")}
            defaultValue={""}
            className="more-border-radius"
            autoComplete="username"
            required
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>{_t("Password")}</Form.Label>
          <Form.Control
            type="password"
            name="password"
            placeholder={_t("Enter password")}
            className="more-border-radius"
            autoComplete="current-password"
            required
          />
        </Form.Group>
        <Link to="/public/forgotten-password" className="w-100 text-white text-center d-block my-1">
          {_t("Forgotten your password?")}
        </Link>
        <Button id="login-button" variant="outline-light my-3" className="w-100 more-border-radius" type="submit">
          {_t("Log In")}
        </Button>

        {!navigator.onLine && <NoInternetMsg />}
        {location.search.includes("auth-fail") && (
          <ErrorMsg
            title={_t("Authentication Failed")}
            body={_t("Please check your username and password and try again.")}
          />
        )}
        {location.search.includes("inactive") && (
          <ErrorMsg
            title={"Account Inactive"}
            body={"Your account is no longer active. Please contact your sales representative."}
          />
        )}
        {location.search.includes("jpn-gi") && (
          <ErrorMsg
            title={_t("The Global Research Portal is not available for your account.")}
            body={_t(
              "The Global Research Portal is for Professional Investors. If you have any questions regarding this service, please contact Nomura Sales."
            )}
          />
        )}
        {location.search.includes("unexpected") && (
          <ErrorMsg
            title={_t("Error Logging In")}
            body={_t("A server error has occurred. Please wait a few moments, and try again.")}
          />
        )}
        {location.search.includes("account-locked") && (
          <ErrorMsg
            title={_t("Account Locked!")}
            body={_t(
              'Your account is locked due to excessive failed login attempts. To unlock your account, please reset your password by clicking "Forgotten your password?" below.'
            )}
          />
        )}
        {location.search.includes("new-pw") && (
          <ErrorMsg
            title={_t("Password updated")}
            body={_t("Your password has been updated. Please use your new password to login.")}
          />
        )}

        {getMagicLink()}

        <Link to="/public/faq" className="w-100 text-white text-center d-block my-1">
          {_t("FAQ")}
        </Link>

        <Link to="/public/login-support" className="w-100 text-white text-center d-block my-1">
          {_t("Need Support?")}
        </Link>
        <LoginTerms />
      </Form>
    </section>
  );
};

export const NoInternetMsg = () => (
  <Alert variant="warning">{_t("Please check you have internet connectivity.")}</Alert>
);